module.exports = __webpack_public_path__ + "img/social_economy_color.3a4b3c92.svg";